import { render } from "./ConfirmPassword.vue?vue&type=template&id=d2091dcc"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dmp/releases/1776447368/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__